import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { EMPTY, merge, of } from 'rxjs'
import { catchError, map, mergeMap } from 'rxjs/operators'
import {
  normalizeHttpError,
  ProductActions,
  ScopedProductData,
  SiteContextActions,
  withdrawOn
} from '@spartacus/core'
import { MbProductConnector } from '../../connectors'
import { bufferDebounceTime } from '../../../shared/utils/buffer-debounce-time'
import { MbProductAction } from '../actions'

@Injectable()
export class MbProductEffects {
  // we want to cancel all ongoing requests when currency or language changes,
  private contextChange$ = this.actions$.pipe(
    ofType(
      SiteContextActions.CURRENCY_CHANGE,
      SiteContextActions.LANGUAGE_CHANGE
    )
  )

  loadProduct$ = createEffect(() => ({ scheduler, debounce = 0 } = {}) =>
    this.actions$.pipe(
      ofType(MbProductAction.MB_LOAD_PRODUCT),
      map((action: MbProductAction.MbLoadProduct) => ({
        urlEncodedName: action.payload,
        scope: action.meta.scope,
      })),
      // we are grouping all load actions that happens at the same time
      // to optimize loading and pass them all to productConnector.getMany
      bufferDebounceTime(debounce, scheduler),
      mergeMap((products: any[]) => merge(...this.productConnector.getMany(products).map(this.productLoadEffect))),
      withdrawOn(this.contextChange$)
    )
  )

  private productLoadEffect (productLoad: ScopedProductData) {
    return productLoad.data$?.pipe(
      map(data => new ProductActions.LoadProductSuccess({
          ...data,
          code: productLoad.urlEncodedName
        }, productLoad.scope)
      ),
      catchError(error => of(new ProductActions.LoadProductFail(
          productLoad.code,
          normalizeHttpError(error),
          productLoad.scope
        ))
      )
    ) || EMPTY
  }

  constructor (private actions$: Actions,
               private productConnector: MbProductConnector) {}
}
